export const emailFontFamilyStyle =
  "font-family: Arial, Helvetica, sans-serif;";

export const emailBodyTextStyle = `${emailFontFamilyStyle} font-size: 16px; line-height: 24px;`;
